import { render } from "./CloneComputeOffering.vue?vue&type=template&id=a4025490&scoped=true"
import script from "./CloneComputeOffering.vue?vue&type=script&lang=js"
export * from "./CloneComputeOffering.vue?vue&type=script&lang=js"

import "./CloneComputeOffering.vue?vue&type=style&index=0&id=a4025490&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4025490"]])

export default __exports__